import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";

const  ChangePasswordModal = ({
  isOpen,
  onClose,
  onConfirm,
  customerName,
}) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      setError("كلمات المرور غير متطابقة");
      return;
    }
    if (password.length < 6) {
      setError("كلمة المرور يجب أن تكون 6 أحرف على الأقل");
      return;
    }

    setIsProcessing(true);
    setError("");
    try {
      await onConfirm(password);
      setPassword("");
      setConfirmPassword("");
      onClose();
    } catch (err) {
      setError("حدث خطأ أثناء تحديث كلمة المرور");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden">
        <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
          <div className="flex items-center gap-2">
            <Icon name="Key" className="text-primary" size={20} />
            <h2 className="text-lg font-bold text-gray-800">
              تغيير كلمة المرور
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-sm text-gray-600">
            تعديل كلمة المرور للمستخدم:{" "}
            <span className="font-bold text-gray-900">{customerName}</span>
          </p>

          <Input
            type="password"
            label="كلمة المرور الجديدة"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Input
            type="password"
            label="تأكيد كلمة المرور"
            placeholder="••••••••"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />

          {error && (
            <p className="text-xs text-red-500 bg-red-50 p-2 rounded border border-red-100">
              {error}
            </p>
          )}
        </div>

        <div className="p-6 border-t border-gray-100 flex justify-end gap-3">
          <Button variant="outline" onClick={onClose} disabled={isProcessing}>
            إلغاء
          </Button>
          <Button
            onClick={handleSubmit}
            loading={isProcessing}
            disabled={isProcessing || !password}
          >
            تحديث كلمة المرور
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;